export default __webpack_public_path__ + "static/media/IMG_4340 - ME_C_09_170_ Deekshith Naik.ad118824.jpeg";